import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Tools({ color = 'icon.primary', fill = 'transparent', strokeWidth = '1.5', ...props }) {
  return (
    <IconBase viewBox='0 0 21 20' {...props}>
      <Path
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='m9.93 13.328 5 5a2.122 2.122 0 0 0 3 0v0a2.122 2.122 0 0 0 0-3l-5-5'
      />
      <Path
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='M19.007 4.177a.19.19 0 0 1 .05.085c.47 1.567.107 3.33-1.131 4.568-1.251 1.25-3.038
        1.609-4.617 1.117l-8.347 8.347c-.813.813-2.14.874-2.98.09a2.122 2.122
        0 0 1-.056-3.054l8.383-8.383c-.492-1.58-.134-3.366 1.117-4.617 1.238-1.238
        3-1.602 4.568-1.132a.2.2 0 0 1 .085.05l.162.163a.2.2 0 0 1 0 .283L13.606
        4.33l2.32 2.32 2.636-2.636a.2.2 0 0 1 .283 0l.162.163v0ZM1.026 2.623 1.7
        4.646a1 1 0 0 0 .949.684h2.279V3.051a1 1 0 0 0-.684-.949L2.22 1.428a.5.5
        0 0 0-.512.121l-.562.562a.5.5 0 0 0-.121.512v0Z'
        clipRule='evenodd'
      />
      <Path
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='m4.938 5.328 3.5 3.5'
      />
    </IconBase>
  )
}

Tools.propTypes = {
  color: PropTypes.string,
  secondaryColor: PropTypes.string,
  strokeWidth: PropTypes.string,
  fill: PropTypes.string,
}

export default Tools
